import cn from 'clsx';

const LoadingIndicator = ({
  wrapperClassName,
  backgroundColorClassName = 'bg-neutral-700',
}: {
  wrapperClassName?: string;
  backgroundColorClassName?: string;
}) => {
  return (
    <div className={cn('relative w-16 h-16', wrapperClassName)}>
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="absolute left-1/2 top-0 w-[9.375%] h-[50%] -ml-[4.6875%] animate-fade"
          style={{
            transformOrigin: 'bottom center',
            transform: `rotate(${i * 45}deg)`,
            animationDelay: `${-1 + i * 0.125}s`,
          }}
        >
          <div
            className={cn(
              'w-full h-1/2 mt-1 rounded-full',
              backgroundColorClassName,
            )}
          />
        </div>
      ))}
    </div>
  );
};

export default LoadingIndicator;
